import { createLogic } from "redux-logic";
import Debug from "../../../../../common-deprecated/Debug";
import type { AlternativeType } from "../../../../../common-deprecated/types/CommonTypes";
import { addErrorLog, addRequestLog } from "../../../../../common-deprecated/redux/actions/UtilActions";
import type { CarConfigLogicType } from "../store";
import { finishEtaLoad, resetEta, startEtaLoad } from "../slices/CarConfigEtaSlice";
import etaClient from "../../../../shared-logic/api-clients/eta";
import { getFetcher } from "../../../../../common-deprecated/api-clients/ApiClient";

const startEtaLoadLogic = (createLogic as CarConfigLogicType<ReturnType<typeof startEtaLoad>>)({
    type: startEtaLoad.type,

    validate({ getState, action }, allow, reject) {
        const { eta, carConfigSettings } = getState();
        if (eta.loading || !carConfigSettings.showETA) {
            (reject as () => void)();
        } else {
            allow(action);
        }
    },

    async process({ getState }, dispatch, done) {
        try {
            const { car, basket, commonSettings, carConfigSettings } = getState();

            const fetcher = getFetcher(etaClient, {
                commonSettings,
                model: car.model.id,
                car: car.id,
                colour: basket.colour.internalCode,
                upholstery: basket.upholstery.internalCode,
                etaMatchingType: carConfigSettings.etaMatchingType,
            });
            const etaConfig = await fetcher();

            const { fetchResult, reqLogs, errorLogs } = etaConfig;

            if (reqLogs?.length) dispatch(addRequestLog(reqLogs));
            if (errorLogs?.length) dispatch(addErrorLog(errorLogs));

            // add price of Colour and Upholstery to the total price
            fetchResult.alternatives.forEach((alt: AlternativeType) => {
                alt.price.cash += alt.colour.price.cash + alt.upholstery.price.cash;
                alt.price.discount += alt.colour.price.discount + alt.upholstery.price.discount;
            });
            dispatch(finishEtaLoad({ eta: fetchResult }));
        } catch (exception) {
            Debug.error("Failed to get ETA", exception);
            dispatch(resetEta(true));
        }

        done();
    },
});

export default [startEtaLoadLogic];
